import { IFilterControl } from "../../models/report-interface";
import { Component, EventEmitter, Input, Output} from "@angular/core";
declare var $: any;

@Component({
    selector: "reportCriteria",
     template: `
       <div>
         <!-- REPORT CRITERIA SUMMARY -->
         <div *ngIf="!active" class="ui column doubling grid summary">
           <div class="row">
             <div [ngClass]="control.sizeClass" *ngFor="let control of criteriaControls">
               <reportSummaryField [title]="control.title" [detail]="control.selectedText"
                                   [isNumber]="false"></reportSummaryField>
             </div>
           </div>
         </div>
         <!-- CHANGE REPORT CRITERIA FORM UI -->
         <div *ngIf="active" class="ui form noPrint">
           <div class="fields">
             <div [ngClass]="control.sizeClass" class="field"
                  *ngFor="let control of criteriaControls" [ngSwitch]="control.type">
               <ng-template [ngSwitchCase]="'DropDownReferenceDataFilter'">
                 <dropDownReferenceDataFilter [filterControl]="control">
                 </dropDownReferenceDataFilter>
               </ng-template>
               <ng-template [ngSwitchCase]="'TextFilter'">
                 <inputFilter [filterControl]="control"></inputFilter>
               </ng-template>
               <ng-template [ngSwitchCase]="'DateRangeFilter'">
                 <ng2common-date-picker [name]="control.name" [startDate]="control.selectedData.date1"
                                        [endDate]="control.selectedData.date2" [maxDate]="control.data[1].date2"
                                        [minDate]="control.data[1].date1" (datePicked)="onDatePicked($event,control)">
                 </ng2common-date-picker>
               </ng-template>
             </div>
           </div>
           <div class="ui column grid paddingBottom">
             <div class="sixteen wide column right aligned">
               <button id="criteriaCancelButton" class="ui button compact"
                       (click)="onCriteriaCancel()">Cancel
               </button>
               <button id="criteriaApplyButton" class="ui primary button compact"
                       (click)="onCriteriaApply($event)">Run Report
               </button>
             </div>
           </div>
         </div>
       </div>
     `,
})

export class ReportCriteriaComponent {
    @Input() public criteriaControls: Array<IFilterControl>;
    @Input() public active: boolean;
    @Output() public criteriaApply: EventEmitter<any> = new EventEmitter();

    private initialSelectedValues: Array<string> = [];

    public ngOnInit(): any {
        if (this.criteriaControls != null) {
            for (let i = 0; i < this.criteriaControls.length; i++) {
                this.initialSelectedValues.push(this.criteriaControls[i].selectedData);
            }
        }

    }

    public onCriteriaApply(event) {
        this.active = false;

        for (let i = 0; i < this.criteriaControls.length; i++) {
            this.initialSelectedValues.push(this.criteriaControls[i].selectedData);
        }

        this.criteriaApply.emit(this.criteriaControls);
    }

    public onCriteriaCancel() {
        this.active = false;

        for (let i = 0; i < this.criteriaControls.length; i++) {
            this.criteriaControls[i].selectedData = this.initialSelectedValues[i];
        }

        this.criteriaApply.emit(null);
    }

    public onDatePicked(event, control: IFilterControl) {
        control.selectedData.date1 = event.startDate;
        control.selectedData.date2 = event.endDate;
    }
}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/report-criteria-component.ts